module.exports = __webpack_public_path__ + "static/img/4c601020-3146-4373-8d28-81ce9ca9a845.001.573894e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4c601020-3146-4373-8d28-81ce9ca9a845.001.jpeg
// module id = mtBu
// module chunks = 1